import request from '@/http/http'
const PREFIX = 'api/deer/estatemarketing/';
// 获取佣金方案列表
export function getCommissions(id) {
    return request({
        url:PREFIX+id+'/commission-list'
    })
}
// 创建佣金方案
export function createCommission(id,data) {
    return request({
        url: PREFIX+id+'/create-commission',
        method: 'post',
        data
    })
}
// 更新佣金方案
export function updateCommission(id,data) {
    return request({
        url: PREFIX+id+'/update-commission',
        method: 'put',
        data
    })
}
// 隐藏佣金方案
export function updateCommissionDisable(id,commissionId,isDisable) {
    return request({
        url: PREFIX+id+'/update-commission-disable/'+commissionId+'?isDisable='+isDisable,
        method: 'put',
    })
}
// 删除佣金方案
export function deleteCommission(id,commissionId) {
    return request({
        url: PREFIX+id+'/delete-commission/'+commissionId,
        method: 'delete'
    })
}
// 获取报备规则
export function getReservationRule(id) {
    return request({
        url:PREFIX+id+'/reservation-rule'
    })
}
// 更新报备规则
export function updateReservationRule(id,data) {
    return request({
        url:PREFIX+id+'/update-reservationrule',
        method: 'put',
        data
    })
}
// 获取楼盘来访规则
export function getVisitRule(id) {
    return request({
        url:PREFIX+id+'/visitrule'
    })
}
// 更新楼盘来访规则
export function updateVisitRule(id,data) {
    return request({
        url:PREFIX+id+'/update-visitrule',
        method: 'put',
        data
    })
}
// 获取楼盘结佣规则
export function getSettlementRule(id) {
    return request({
        url:PREFIX+id+'/settlementrule'
    })
}
// 更新楼盘结佣规则
export function updateSettlementRule(id,data) {
    return request({
        url:PREFIX+id+'/update-settlementrule',
        method: 'put',
        data
    })
}
// 获取奖励方案列表
export function getAwards(id) {
    return request({
        url:PREFIX+id+'/award-list'
    })
}
// 添加奖励方案
export function createAward(id,data) {
    return request({
        url: PREFIX+id+'/create-award',
        method: 'post',
        data
    })
}
// 删除奖励方案
export function deleteAward(id,awardId) {
    return request({
        url: PREFIX+id+'/award/'+awardId,
        method: 'delete'
    })
}
// 隐藏奖励方案
export function updateAwardDisable(id,awardId,isDisable) {
    return request({
        url: PREFIX+id+'/update-award-disable/'+awardId+'?isDisable='+isDisable,
        method: 'put',
    })
}
// 更新奖励方案
export function updateAward(id,data) {
    return request({
        url:PREFIX+id+'/update-award',
        method: 'put',
        data
    })
}
// 获取项目动态列表
export function getDynamics(id,query) {
    return request({
        url:PREFIX+id+'/dynamic-page-list',
        params:query
    })
}
// 添加项目动态
export function createDynamic(id,data) {
    return request({
        url: PREFIX+id+'/create-dynamic',
        method: 'post',
        data
    })
}
// 更新项目动态
export function updateDynamic(id,data) {
    return request({
        url:PREFIX+id+'/update-dynamic',
        method: 'put',
        data
    })
}
// 发布项目动态
export function publishDynamic(id,dynamicId) {
    return request({
        url:PREFIX+id+'/publish-dynamic/'+dynamicId,
        method: 'put',
    })
}
// 置顶项目动态
export function topDynamic(id,dynamicId) {
    return request({
        url:PREFIX+id+'/top-dynamic/'+dynamicId+'?isTop=true',
        method: 'put',
    })
}
// 删除项目动态
export function deleteDynamic(id,commissionId) {
    return request({
        url: PREFIX+id+'/delete-dynamic/'+commissionId,
        method: 'delete'
    })
}

// 获取团购方案列表
export function getGroups(id) {
    return request({
        url:PREFIX+id+'/group-list'
    })
}
// 添加团购方案
export function createGroup(id,data) {
    return request({
        url: PREFIX+id+'/create-group',
        method: 'post',
        data
    })
}
// 删除团购方案
export function deleteGroup(id,groupId) {
    return request({
        url: PREFIX+id+'/delete-group/'+groupId,
        method: 'delete'
    })
}
// 隐藏团购方案
export function updateGroupDisable(id,groupId,isDisable) {
    return request({
        url: PREFIX+id+'/update-group-disable/'+groupId+'?isDisable='+isDisable,
        method: 'put',
    })
}
// 更新团购方案
export function updateGroup(id,data) {
    return request({
        url:PREFIX+id+'/update-group',
        method: 'put',
        data
    })
}